import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  // This theme service brought to you by Bobe, Nerezi Gang
  constructor() {
    this.applyExistingTheme();
  }

  changeActiveTheme(value: string): void {
    const bodyElement = document.getElementById('body');
    bodyElement?.setAttribute('data-theme', value);
    this.setLocalStorageTheme(value);
  }

  public get themeFromLocalStorage(): string | null {
    return localStorage.getItem('theme') ? localStorage.getItem('theme') : null;
  }

  setLocalStorageTheme(themeName: string): void {
    localStorage.setItem('theme', themeName);
  }

  applyExistingTheme(): void {
    if (this.themeFromLocalStorage) {
      this.changeActiveTheme(this.themeFromLocalStorage);
    } else {
      this.changeActiveTheme('dark');
    }
  }
}
